import { makeContextModule } from '@cian/react-utils';

import { FC, PropsWithChildren } from 'react';

import { MapHTMLContainer } from 'shared/components/MapHTMLContainer';
import { useInitYandexMap } from 'shared/hooks/useInitYandexMap';
import { MapContextSafe, ensureMapContextInitialized } from 'shared/types/MapContext';

export const {
  Context,
  useContext: useMapContext,
  withContext: withMapContext,
} = makeContextModule<MapContextSafe>({
  contextName: 'MapContext',
});

export const MapContextProvider: FC<PropsWithChildren> = props => {
  const { children } = props;
  const value = useInitYandexMap();
  const { createMapInstance, context } = value;

  if (ensureMapContextInitialized(context)) {
    return (
      <Context.Provider value={context}>
        <MapHTMLContainer createMapInstance={createMapInstance} />
        {children}
      </Context.Provider>
    );
  }

  return <MapHTMLContainer createMapInstance={createMapInstance} />;
};
